import { render, staticRenderFns } from "./BadTypePopup.vue?vue&type=template&id=56e7d790&scoped=true&"
import script from "./BadTypePopup.vue?vue&type=script&lang=js&"
export * from "./BadTypePopup.vue?vue&type=script&lang=js&"
import style0 from "./BadTypePopup.vue?vue&type=style&index=0&id=56e7d790&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e7d790",
  null
  
)

export default component.exports